// postOnboardingStart.ts — a one-shot, in-memory hand-off from the onboarding needs-check
// reveal to App: which door the person chose. Never persisted. App takes it when onboarding
// genuinely completes; no value (e.g. the 'entry' screen path) means the default: land in
// lesson 1.
export type PostOnboardingStart = 'lesson' | 'settle' | 'explore';

let pending: PostOnboardingStart | null = null;

export function setPostOnboardingStart(s: PostOnboardingStart): void { pending = s; }

export function takePostOnboardingStart(): PostOnboardingStart | null {
  const s = pending;
  pending = null;
  return s;
}
